module.exports = __webpack_public_path__ + "img/emergency-contraception_x2.a75f9609.png";